import { fetchApi } from "../DataApi/fetchApi";

export async function logoutSession() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "text/plain");

  const requestOption = {
    method: "GET",
  };
  return fetchApi({
    requestOption,
    endpoint: `/web/session/logout`,
    headers: {},
  });
}
